import { RadioGroup } from 'components/RadioGroup/RadioGroup'
import { styled } from 'stitches.config'

export const Option = styled(RadioGroup.Option, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  color: '$accent-black',
  padding: '20px 16px',
  backgroundColor: '$accent-white',
  minWidth: 'unset',
  border: '1px solid $accent-gray',
  flexWrap: 'nowrap',
  gap: '$1',
  flex: '1 1 0px',
  transition: 'all 0.3s ease',
  width: '100%',

  '&:before': {
    content: '',
    position: 'relative',
    display: 'flex',
    height: '24px', 
    minWidth: '24px', 
    backgroundColor: '$accent-white',
    border: '1px solid $accent-black',
    borderRadius: '$round',
    marginRight: '0',
    transition: 'all 0.3s ease',
  },

  '& label': {
    fontSize: '$body',
    height: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
  },

  '&:hover': {
    cursor: 'pointer',
  },

  '&[data-state="checked"]': {
    color: '$accent-black',
    backgroundColor: '$tertiary-200',
    border: '1px solid $primary-500',
    '&:before': {
      border: '1px solid $primary-500',
      backgroundColor: '$primary-500',
      boxShadow: '0 0 0 3px white inset',
    },
  },

  '@bp2': {
    padding: '20px 24px',
    minWidth: '226px',
    '&:before': {
      marginRight: '8px',
    },
    '&:hover': {
      border: '1px solid $primary-500',
    },
  },
})